import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchUnitAction = createAsyncThunk("fetch/units", async function ({ page, perPage }, thunkApi) {
    try {
        const response = await api.get("/units", {
            params: {
                page, perPage
            }
        });


        if (response.data.status == "success") {
            return {data:response.data.data,totalPages:response.data.totalPages};
        }
        return;
    } catch (error) {
        return thunkApi.rejectWithValue(error.response.data.message);
        // return /error;
    }
});

export const unitSlice = createSlice({
    name: "unit",
    initialState: {
        loading: false,
        error: null,
        units: [],
        totalPages:0,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchUnitAction.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchUnitAction.fulfilled, (state, action) => {
                state.loading = false;
                state.units = action.payload.data;
                state.totalPages = action.payload.totalPages;
            })
            .addCase(fetchUnitAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export default unitSlice.reducer;